import { DialogModule } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { UserPasswordResetRequestComponent } from './containers/user-password-reset-request.component';
import { UserPasswordResetRequestEffects } from './state/user-password-reset-request.effects';
import * as fromUserPasswordResetRequest from './state/user-password-reset-request.reducer';
import { UserPasswordResetRequestViewComponent } from './views/user-password-reset-request-view.component';

@NgModule({
   declarations: [UserPasswordResetRequestComponent, UserPasswordResetRequestViewComponent],
   imports: [
      CommonModule,
      DialogModule,
      EntitySelectModule,
      LcsLoadingOverlayModule,
      MatButtonModule,
      MatDialogModule,
      MatIconModule,
      LcsCallStatePipeModule,
      MatInputModule,
      ReactiveFormsModule,
      StoreModule.forFeature(
         fromUserPasswordResetRequest.userPasswordResetRequestFeatureKey,
         fromUserPasswordResetRequest.reducer
      ),
      EffectsModule.forFeature([UserPasswordResetRequestEffects]),
   ],
})
export class UserPasswordResetRequestModule {}
